(function ($) {
  "use strict";

  /*** Slim Select ***/
  $.each($(".fr-select"), function (key, item) {
    new SlimSelect({
      select: item,
      settings: {
        showSearch: false,
        hideSelected: false,
      },
    });
  });

  /*** Slick ***/
  $(".slick").slick();
  $("#shopify-section-announcement-bar .slick").slick("refresh");

  $('a[data-toggle="tab"]').on("shown.bs.tab", function (e) {
    $(".slick").slick("setPosition");
  });

  $(".product--navs .slick-slide").on("click", function (event) {
    $(".product--slider").slick("slickGoTo", $(this).data("slickIndex"));
  });

  /*** Sticky Header ***/
  $(window).scroll(function () {
    if ($(window).scrollTop() >= 125) {
      $("#header").addClass("header--sticky");
    } else {
      $("#header").removeClass("header--sticky");
    }
  });

  /*** Footer Accordion ***/
  $(".footer .collapse").on("show.bs.collapse", function () {
    $(".footer .collapse").not(this).collapse("hide");
  });

  /*** Hover Header ***/
  if ($(window).width() > 992) {
    if (!$("#header").hasClass("header--hovered")) {
      $(".header--megamenu--item")
        .mouseover(function () {
          $("#header").addClass("header--hovered");
        })
        .mouseout(function () {
          $("#header").removeClass("header--hovered");
        });
    }

    $("#header .dropdown").on("show.bs.dropdown", function () {
      $("#header").addClass("header--hovered");
    });

    $("#header .dropdown").on("hide.bs.dropdown", function () {
      $("#header").removeClass("header--hovered");
    });
  }

  $("#header-search").on("show.bs.collapse", function () {
    $("#header").addClass("header--hovered");
  });

  $("#header-search").on("hide.bs.collapse", function () {
    $("#header").removeClass("header--hovered");
  });

  /*** Scroll To Top ***/
  $(".backtotop").click(function (event) {
    event.preventDefault();
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });

  /*****minicart laterale*****/
  document.addEventListener("DOMContentLoaded", () => {
    var minicart = new MmenuLight(document.querySelector("#minicart"));

    const drawer = minicart.offcanvas({
      position: "right",
    });

    document
      .querySelector('a[href="#minicart"]')
      .addEventListener("click", (evnt) => {
        evnt.preventDefault();
        drawer.open();
      });

    var $closeMinicart = $(".closeMinicart");

    $closeMinicart.on("click", function () {
      drawer.close();
    });

    var $openMinicart = $(".openMinicart");

    $openMinicart.on("click", function () {
      drawer.open();
    });

		document.addEventListener("product-added-to-cart", () => {
			drawer.open();
		})
  });

  /*******************/
  $(document).on("click", ".btnChanger", function (e) {
    $("#minicart #left").hide();
    $("#firstLayer").hide();
    $("#topFirstLayer").hide();

    if (e.target.dataset.step) {
      $(`#topSecondlayer-s${e.target.dataset.step}`).fadeIn();
      $(`#secondLayer-s${e.target.dataset.step}`).fadeIn();
    }
    $("#minicart #right").removeClass("border-start");
  });

  $(".backfirstLayer").click(function () {
    $("#minicart #left").fadeIn();
    $("#firstLayer").fadeIn();
    $("#topFirstLayer").fadeIn();
    // hide all layers
    $("#topSecondlayer-s1").hide();
    $("#secondLayer-s1").hide();
    $("#topSecondlayer-s2").hide();
    $("#secondLayer-s2").hide();
    $("#topSecondlayer-s3").hide();
    $("#secondLayer-s3").hide();
    //  end
    $("#minicart #right").addClass("border-start");
    $(".slick").slick("refresh");
  });
  /***** end minicart laterale*****/

  var prevScrollTop = $(window).scrollTop();

  $(window).on("scroll", function (e) {
    var currentScrollTop = $(this).scrollTop();

    if (currentScrollTop <= prevScrollTop && currentScrollTop > 94) {
      $(".backtotop").fadeIn();
    } else {
      $(".backtotop").fadeOut();
    }

    prevScrollTop = currentScrollTop;
  });

  /*** Mobile Menu ***/
  var menu = new MmenuLight(
    document.querySelector("#header-mobile"),
    "(max-width: 992.98px)"
  );

  var navigator = menu.navigation({
    theme: "light",
    title: "",
    slidingSubmenus: false,
  });

  document.addEventListener("DOMContentLoaded", () => {
    const drawer = menu.offcanvas();

    var $burgerbutton = $(".header--burger");

    $burgerbutton.on("click", function () {
      $burgerbutton.toggleClass("is-active");
      if ($(".mm-ocd").hasClass("mm-ocd--open")) {
        drawer.close();
      } else {
        drawer.open();
        $("#header-search").insertAfter($("#header-mobile li:first-child"));
      }
    });

    var $clostBtn = $(".header--mobile--close");

    $clostBtn.on("click", function () {
      drawer.close();
    });

    var $linkitem = $(".header--mmenu--item");

    $linkitem.on("click", function () {
      $(this).toggleClass("active").siblings().removeClass("active");
    });
  });

  /*** Filters Shadow ***/
  $(document).click(function () {
    $("#filters .dropdown-menu.show").closest("filter--toggle").click();
  });

  if ($(window).width() > 767.98) {
    $("body").on("DOMSubtreeModified", "#AjaxinateContainer", function () {
      $(document).click(function () {
        $("#filters .dropdown.show, #filters .dropdown-menu.show").removeClass(
          "show"
        );
      });
    });
  }

  $(document).on("click", "#filters .dropdown-menu", function (e) {
    e.stopPropagation();
  });

  $(".filters--togglemobile").on("click", function () {
    $('<div class="filters--open"></div>').appendTo(document.body);
    $("html").addClass("noscroll");
  });

  $(document).on("click", ".filters--close", ".filter--apply", function () {
    $(".filters--open").remove();
    $("html").removeClass("noscroll");
  });

  $(document).on("click", ".filters--open", function () {
    $(".filters--close").click();

    if (!$("#filters").hasClass("show")) {
      $(".filters--open").remove();
      $("html").removeClass("noscroll");
    }
  });

  $(document).on("click", ".filter--apply", function () {
    $(".filters--close").click();

    if (!$("#filters").hasClass("show")) {
      $(".filters--open").remove();
      $("html").removeClass("noscroll");
    }
  });

  /*** Light Gallery ***/
  if ($("body").attr("class").includes("template-product")) {
    lightGallery(document.getElementById("prodslider"), {
      plugins: [lgZoom],
      selector: ".product--slider--item:not(.slick-cloned)",
      speed: 500,
      enableDrag: false,
      counter: false,
      download: false,
      showCloseIcon: true,
      mobileSettings: {
        controls: true,
        showCloseIcon: true,
      },
    });
  }

  /*** Readmore ***/
  var readmoreInstance = new Readmore();
  readmoreInstance.render();

  // Device type function
  function deviceType() {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return "tablet";
    } else if (
      /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua
      )
    ) {
      return "mobile";
    }
    return "desktop";
  }

  /*** Sticky Product Info ***/
  // if ($(window).width() > 991.98) {
  //     var headerHeight = $('#header').height();
  // 	var fichesticky = $('.product--fiche')?.offset()?.top;
  // 	var ficheHeight = $('.product--fiche').height();

  // 	$(window).scroll(function() {
  // 	    var currentScroll = $(window).scrollTop();

  // 	    if ((currentScroll + headerHeight) >= fichesticky && (currentScroll + ficheHeight) <= $('.product--container').offset().top + $('.product--container').height()) {
  // 	        $('.product--fiche').css({
  // 	            position: 'fixed',
  // 	            top: headerHeight + 'px',
  // 	            'z-index': '1050'
  // 	        });
  // 	    }
  // 	    else {
  // 	        $('.product--fiche').css({
  // 	            position: 'relative',
  // 	            top: '0'
  // 	        });
  // 	    }

  // 	    if ((currentScroll + ficheHeight) >= $('.product--container')?.offset()?.top + $('.product--container')?.height()) {
  // 	    	$('.product--fiche').css({
  // 	            position: 'absolute',
  // 	            bottom: '0',
  // 	            top: 'initial'
  // 	        });
  // 	    }
  // 	});
  // }

  /***************************/
  /******* scrollToTop *******/
  /***************************/
  function scrollToTop() {
    var $scrollUp = $("#BackToTop"),
      $lastScrollTop = 0,
      $window = $(window);

    $window.on("scroll", function () {
      var st = $(this).scrollTop();
      if (st > $lastScrollTop) {
        $scrollUp.css({ bottom: "-110px" });
      } else {
        if ($window.scrollTop() > 200) {
          $scrollUp.css({ bottom: "110px" });
        } else {
          $scrollUp.css({ bottom: "-110px" });
        }
      }
      $lastScrollTop = st;
    });

    $scrollUp.on("click", function (evt) {
      $("html, body").animate({ scrollTop: 0 }, 600);
      evt.preventDefault();
    });
  }
  scrollToTop();
})(jQuery);
